module.exports.referenceEnergies = {
  N2: { G: -19.97428184, nelec: 10 },
  NH3: { G: -11.7667212, nelec: 8 },
  H2: { G: -1.167407007, nelec: 2 },
  "H+": { G: -0.583703504, nelec: 0 },
  CO: { G: -21.759575948786324, nelec: 10 },
  CO2: { G: -37.89554174841674, nelec: 16 },
  H2O: { G: -17.284950957331414, nelec: 8 },
  O2: { G: -32.04134996834167, nelec: 12 },
  OCHO: { G: -38.626982043943734, nelec: 18 },
  CH4: { G: -8.064471562218662, nelec: 8 },
};

module.exports.referenceTable = {
  "N2*": { "H+": 6 },
  "N2H*": { "H+": 5 },
  "NNH2*": { "H+": 4 },
  "N*": { NH3: 1, "H+": 3 },
  "NH*": { NH3: 1, "H+": 2 },
  "NH2*": { NH3: 1, "H+": 1 },
  "NH3*": { NH3: 1 },
  "H*": { "H+": 1 },
  "NHNH*": { "H+": 4 },
  "NHNH2*": { "H+": 3 },
  "NH2NH2*": { "H+": 2 },
  "NNH3*": { "H+": 3 },
  "NHNH3*": { "H+": 1 },
  "NH2NH3*": { "H+": 0 },
  "CO2*": { "H+": 2 },
  "COOH*": { "H+": 1 },
  "CO*": { H2O: 1 },
  "CHO*": { H2O: 1, "H+": 5 },
  "COH*": { H2O: 1, "H+": 1 },
  "OCHO*": { "H+": 1 },
  "OOH*": { "H+": 3 },
  "OH*": { H2O: 1, "H+": 1 },
  "O*": { H2O: 1, "H+": 2 },
  "H2O*": { H2O: 1 },
  // HER
  "2H+": { "H+": 2 },
  H2: { H2: 1 },
  // NRR
  N2: { N2: 1, "H+": 6 },
  "2NH3": { NH3: 2 },
  // CO2R
};

module.exports.reactionTerminations = {
  NRR: { initial: { N2: 1, H1: 6 }, final: { NH3: 2 } },
  HER: { initial: { H1: 2 }, final: { H2: 1 } },
  CO2R_CO: { initial: { CO2: 1, H1: 2 }, final: { CO: 1, H2O: 1 } },
  OER: { initial: { H2O: 2 }, final: { O2: 1, H1: 4 } },
  CO2R_CH4: { initial: { CO2: 1, H1: 8 }, final: { CH4: 1, H2O: 2 } },
  CO2R_OCHO: { initial: { CO2: 1, H1: 1 }, final: { OCHO: 1 } },
};

module.exports.terminationLabels = {
  NRR: { initial: "N2", final: "2NH3" },
  HER: { initial: "2H+", final: "H2" },
  CO2R: { initial: "CO2", final: "CO" },
  OER: { initial: "2H2O", final: "O2" },
};

module.exports.stateIndices = {
  NRR: ["N2", "N2*", "N2H*", "NNH2*", "N*", "NH*", "NH2*", "NH3*", "2NH3"],
  HER: ["2H+", "H*", "H2"],
  OER: ["2H2O", "OH*", "O*", "OOH*", "O2*", "O2"],
  // CO2R
  CO2R_CO: ["CO2", "COOH*", "CO*", "CHO*", "CO"],
  CO2R_CH4: ["CO2", "CHO*", "COH*", "CO"],
  CO2R_OCHO: ["CO2", "OCHO*", "CO"],
};

module.exports.formulaLookup = {
  H: "H1",
  NH: "N1H1",
  N: "N1",
  N2: "N2",
  NNH2: "N2H2",
  NH3: "N1H3",
  NH2: "N1H2",
  N2H: "N2H1",
  O2: "O2",
  CO2: "C1O2",
  COOH: "C1O2H1",
  CO: "C1O1",
  OH: "O1H1",
  O: "O1",
  OOH: "O2H1",
};

module.exports.adsorbatesToMechanisms = {
  H1: "HER",
  N1H1: "NRR",
  N1: "NRR",
  N2: "NRR",
  N2H2: "NRR",
  N1H3: "NRR",
  N1H2: "NRR",
  N2H1: "NRR",
  O2: "OER",
  O1H1: "OER",
  O1: "OER",
  O2H1: "OER",
};
